import { render, staticRenderFns } from "./SaleChartPerson.vue?vue&type=template&id=22391377&scoped=true&"
import script from "./SaleChartPerson.vue?vue&type=script&lang=js&"
export * from "./SaleChartPerson.vue?vue&type=script&lang=js&"
import style0 from "./SaleChartPerson.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SaleChartPerson.vue?vue&type=style&index=1&id=22391377&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22391377",
  null
  
)

export default component.exports